import React, { useState, useEffect } from 'react';
import CardDetail from './CardDetail';
import CardBackground from './CardBackground';
import { getCardStyle } from '../utils/cardStyle';
import { getSurfaceClassName } from '../utils/cardSurface';
import { preloadCardImages } from '../utils/imagePreload';

const CardList = () => {
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [cardUserId, setCardUserId] = useState(null);

  useEffect(() => {
    const loadTelegramSDK = () => {
      if (window.Telegram?.WebApp) {
        window.Telegram.WebApp.expand();
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('userId') || window.Telegram.WebApp.initDataUnsafe?.user?.id || null;
        setCardUserId(id);
      }
    };

    if (typeof window.Telegram === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://telegram.org/js/telegram-web-app.js';
      script.async = true;
      script.onload = loadTelegramSDK;
      document.body.appendChild(script);
    } else {
      loadTelegramSDK();
    }
  }, []);

  useEffect(() => {
    if (!cardUserId) return;
    fetch(`telegram/card-list/${cardUserId}`)
      .then((r) => r.json())
      .then((data) => {
        const nextCards = data.cards || [];
        setCards(nextCards);
        preloadCardImages(nextCards);
      })
      .catch((e) => console.error('Ошибка при загрузке карт:', e));
  }, [cardUserId]);

  return (
    <div className={`wallet ${selectedCard ? 'wallet--detail' : ''}`}>
      <div className="wallet-list-screen" aria-hidden={!!selectedCard}>
        <h2 className="wallet-title">Ваши карты</h2>
        <div className="wallet-list">
          {cards.map((card, index) => {
            const style = getCardStyle(card, { context: 'list' });
            return (
              <button
                key={card.cardNumber}
                type="button"
                className={`wallet-card ${getSurfaceClassName(style.cardStyle)}`}
                style={{ zIndex: index + 1 }}
                onClick={() => setSelectedCard(card)}
                tabIndex={selectedCard ? -1 : 0}
              >
                <CardBackground
                  mainColor={style.mainColor}
                  imageUrl={style.hasPhoto ? style.imageUrl : null}
                  cardStyle={style.cardStyle}
                  backgroundPattern="solid"
                  allowPhoto
                />
                <div className="wallet-card-body">
                  <div className="wallet-card-header">
                    {card.user?.accountName && (
                      <span className="wallet-card-shop" style={{ color: style.textColor }}>
                        {card.user.accountName}
                      </span>
                    )}
                    <img
                      src={style.iconUrl}
                      className="wallet-card-logo"
                      alt=""
                      loading="eager"
                      decoding="async"
                    />
                  </div>
                  <div className="wallet-card-balance-block">
                    <span className="wallet-card-balance-label" style={{ color: style.labelColor }}>
                      Баланс
                    </span>
                    <span className="wallet-card-balance" style={{ color: style.textColor }}>
                      {card.balance.toLocaleString('ru-RU')} ₽
                    </span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {selectedCard && (
        <CardDetail card={selectedCard} onBack={() => setSelectedCard(null)} />
      )}
    </div>
  );
};

export default CardList;
